import { render, staticRenderFns } from "./member-category.vue?vue&type=template&id=675e9716&scoped=true&"
import script from "./member-category.vue?vue&type=script&lang=js&"
export * from "./member-category.vue?vue&type=script&lang=js&"
import style0 from "./member-category.vue?vue&type=style&index=0&id=675e9716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e9716",
  null
  
)

export default component.exports